export default {
  categories: {
    shoes: 'Zapatos',
    hoodies: 'Sudaderas / Suéteres',
    tshirts: 'Camisetas',
    jackets: 'Chaquetas',
    pants: 'Pantalones / Shorts',
    headwear: 'Gorras y sombreros',
    sets: 'Conjuntos',
    underwear: 'Ropa interior',
    jersey: 'Camisetas deportivas',
    accessories: 'Accesorios',
    bags: 'Bolsos',
    belts: 'Cinturones',
    perfumes: 'Perfumes',
    other: 'Otras cosas',
  },
  home: {
  hero: {
    badge: 'Recurso independiente del spreadsheet de USFans',
    h1: 'Spreadsheet de USFans — enlaces de productos, QC y guías de compra',
    subtitle: 'Explora el spreadsheet de USFans: recursos de productos, enlaces útiles, información QC, guías de envío, detalles de almacén, reseñas, cupones y consejos prácticos de compra, todo en un solo lugar.',
    searchPlaceholder: 'Busca productos USFans, enlaces del spreadsheet, QC, envío o guías...',
    ctaPrimary: 'Spreadsheet de USFans',
    ctaSecondary: 'Comprar ahora',
    dropdownLabel: 'Elige una categoría',
    dropdownHint: 'Salta a una categoría del sitio web principal',
    trustLine: 'Recurso gratuito · Sin cuenta · Actualizado regularmente',
  },
  intro: {
    title: '¿Qué es el spreadsheet de USFans?',
    p1: 'El spreadsheet de USFans es un recurso centralizado y organizado que reúne enlaces de productos, detalles de control de calidad (QC), notas de envío y orientación de compra para compradores de streetwear y moda. En lugar de revisar páginas interminables o hilos de chat, los compradores usan un documento ordenado para comparar productos y encontrar justo lo que necesitan.',
    p2: 'Funciona como un punto de partida práctico: elige una categoría, revisa los artículos, consulta las notas de QC y tallas y abre el enlace que quieras en el sitio web principal. Todo lo que necesitas para comprar con confianza está en un solo lugar.',
    point1: 'Enlaces de productos agrupados por categoría',
    point2: 'Referencias de QC y tallas',
    point3: 'Orientación de envío y almacén',
    point4: 'Indicaciones de cupones y descuentos',
  },
  categoriesSection: {
    title: 'Categorías populares',
    subtitle: 'Abre cualquier categoría a continuación para explorar productos coincidentes en el sitio web principal.',
  },
  qc: {
    title: 'QC y controles de calidad',
    body: 'QC significa control de calidad. Antes de enviar un artículo, los compradores suelen revisar fotos para confirmar el color, el logo, las costuras, la talla y el estado general. Una buena rutina de QC implica comprobar las medidas con la tabla de tallas y pedir fotos más claras cuando algo no se ve bien.',
    item1: 'Revisa las fotos antes del envío',
    item2: 'Comprueba las medidas con la tabla de tallas',
    item3: 'Pide nuevas fotos si los detalles no están claros',
    item4: 'Confirma el color, el logo y las costuras',
  },
  review: {
    title: 'Reseña de USFans — ¿es legítimo?',
    body: 'USFansLink.site es un recurso informativo independiente, no una página oficial de la marca. La seguridad de una compra depende de verificar al vendedor, leer reseñas de varias fuentes y usar métodos de pago seguros.',
    legitTitle: 'Compra legítima y segura',
    legit1: 'Verifica al vendedor antes de pagar',
    legit2: 'Lee reseñas de varias fuentes',
    legit3: 'Usa métodos de pago seguros y rastreables',
    legit4: 'Ten cuidado con enlaces sospechosos',
  },
  shipping: {
    title: 'Costo de envío y entrega',
    body: 'El costo de envío y el tiempo de entrega dependen de tu destino, el método de envío y el tamaño del paquete. Algunos compradores consolidan varios artículos a través de un almacén para reducir el costo total.',
    item1: 'Confirma el costo de envío antes de pedir',
    item2: 'Consulta el tiempo de entrega estimado para tu país',
    item3: 'Considera la consolidación de almacén para varios artículos',
  },
  warehouse: {
    title: 'Almacén y almacenamiento',
    body: 'Los pedidos suelen empaquetarse e inspeccionarse en un almacén antes del envío. Los servicios de almacén pueden guardar, inspeccionar y combinar artículos para que envíes varios productos juntos y pagues menos en total.',
  },
  coupon: {
    title: 'Cupones y descuentos',
    body: 'Los códigos de cupón cambian con frecuencia, así que trata cualquier código como temporal. Pruébalo al pagar y usa solo códigos de fuentes de confianza. El spreadsheet puede indicarte ofertas actuales o explicar dónde se publican los descuentos.',
  },
  safety: {
    title: 'Centro de seguridad',
    body: 'Mantente seguro al comprar: evita sitios falsos, verifica los enlaces, protege tus datos de pago y revisa cualquier oferta que parezca demasiado buena para ser real.',
    item1: 'Cuidado con sitios falsos o imitaciones',
    item2: 'Nunca compartas contraseñas ni datos de pago sin cuidado',
    item3: 'Verifica los códigos de cupón antes de pagar',
    item4: 'Revisa los enlaces sospechosos',
  },
  articles: {
    title: 'Últimos artículos',
    subtitle: 'Guías originales para ayudarte a usar el spreadsheet de USFans con confianza.',
    cardTitle: 'Spreadsheet de USFans: la guía completa',
    cardDesc: 'Un recorrido claro de lo que cubre el spreadsheet de USFans, cómo usarlo y cómo comprar de forma segura, desde las categorías hasta el QC, el envío y los cupones.',
    readMore: 'Leer la guía',
    tag: 'Guía',
  },
  faq: {
    title: 'Preguntas frecuentes',
    q1: '¿Qué es el spreadsheet de USFans?',
    a1: 'Es un recurso centralizado que reúne enlaces de productos, categorías, información QC, notas de envío y orientación de compra en un solo lugar organizado.',
    q2: '¿USFansLink.site es una página oficial de USFans?',
    a2: 'No. Es un recurso informativo independiente y no declara afiliación oficial.',
    q3: '¿Cómo uso los enlaces de categoría?',
    a3: 'Elige una categoría en el menú desplegable o en los botones de categoría y abre el enlace correspondiente para explorar productos en el sitio web principal.',
    q4: '¿Los precios y costos de envío siempre están actualizados?',
    a4: 'No. Los precios, el envío y las promociones pueden cambiar, así que verifícalos siempre en la página del producto antes de pagar.',
    q5: '¿Es seguro comprar?',
    a5: 'La seguridad depende de verificar al vendedor, leer reseñas y usar métodos de pago seguros. Ten cuidado con enlaces desconocidos y ofertas que parecen demasiado buenas para ser reales.',
  },
  cta: {
    title: '¿Listo para explorar el spreadsheet completo de USFans?',
    body: 'Abre el sitio web principal para explorar productos, revisar el QC y comparar opciones, todo en un solo lugar.',
    button: 'Ir al sitio web principal',
  },
  disclaimer: 'USFansLink.site es un recurso informativo independiente. Los enlaces externos, productos, precios, información de envío y promociones pueden cambiar. Verifica siempre la información actual antes de comprar o pagar.',
  },
};